import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "image", "display", "next", "close", "prev", "spinner"];

  connect() {
    this.startX = 0;
    if (this.hasDisplayTarget) {
      this.displayTarget.addEventListener("touchstart", this.onTouchStart.bind(this));
      this.displayTarget.addEventListener("touchend", this.onTouchEnd.bind(this));
    }
  }

  openModal(event) {
    console.log(event)
    this.index = parseInt(event.target.dataset.index);

    this.spinnerTarget.classList.remove('hidden')
    this.nextTarget.classList.add('hidden')
    this.prevTarget.classList.add('hidden')
    this.closeTarget.classList.add('hidden')

    this.displayTarget.src = event.target.dataset.imageUrl;

    this.displayTarget.onload = () => {
      this.spinnerTarget.classList.add('hidden')
      this.nextTarget.classList.remove('hidden')
      this.prevTarget.classList.remove('hidden')
      this.closeTarget.classList.remove('hidden')
    }

    this.modalTarget.showModal();
  }

  closeFromBackdropDialog(e) {
    if (e.type == "mousedown" && e.target == this.modalTarget) {
      this.modalTarget.close();
    }
  }

  onTouchStart(event) {
    this.startX = event.touches[0].clientX;
  }

  onTouchEnd(event) {
    const endX = event.changedTouches[0].clientX;
    const diffX = endX - this.startX;
    if (Math.abs(diffX) > 50) { // threshold for swipe
      if (diffX < 0) {
        this.next();
      } else {
        this.prev();
      }
    }
  }

  next() {
    this.index += 1;

    if (this.index >= this.imageTargets.length) {
      this.index = this.imageTargets.length - 1;
    }

    console.log(this.index)

    this.displayTarget.src = this.imageTargets[this.index].dataset.imageUrl;
  }

  prev() {
    this.index -= 1;

    if (this.index < 0) {
      this.index = 0;
    }

    this.displayTarget.src = this.imageTargets[this.index].dataset.imageUrl;
  }

  close() {
    this.modalTarget.close();
  }
}
